module.exports = __webpack_public_path__ + "img/turnstile_0.2cc125ea.jpg";